import React from "react";
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useField } from "formik";
import { TokenInfo, Tokens } from "@chainsafe/web3-context/dist/context/tokensReducer";
import FieldLabel from "../FieldLabel";

import { outlinedInput } from "../../utils/classes";
import HelperText from "../HelperText";

interface ITokenInput {
  disabled?: boolean;
  label: string;
  name: string;
  token: TokenInfo;
  value: number;
  maxValue: number;
  onChange: (value: any) => void;
  setFieldValue: (name: string, value: any) => void;
  error?: string;
}

const TokenInput: React.FC<ITokenInput> = ({
  disabled,
  label,
  token,
  name,
  value,
  maxValue,
  onChange,
  error,
  setFieldValue,
}: ITokenInput) => {
  const [, , helpers] = useField(name);

  return (
    <FormControl fullWidth>
      <FieldLabel label={label} disabled={disabled} />
      <OutlinedInput
        value={value}
        disabled={disabled}
        sx={outlinedInput}
        onChange={onChange}
        error={!!error}
        name={name}
        endAdornment={
          !error ? (
            <InputAdornment
              position="end"
              sx={{ fontWeight: 700 }}
              onClick={(e) => {
                // helpers.setValue(tokens[value[tokenSelectorKey]]?.balance);
                helpers.setValue(maxValue);
                e.preventDefault();
              }}
            >
              MAX
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setFieldValue(name, "")}
                edge="end"
              >
                <CancelIcon color="error" />
              </IconButton>
            </InputAdornment>
          )
        }
      />
      {error && <HelperText error={error} />}
    </FormControl>
  );
};

export default TokenInput;
